module.exports = __webpack_public_path__ + "img/8.024a605b.jpg";